import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import Info from 'components/icons/vipDashboard/Info';
import PrimeLogo from 'components/icons/vipDashboard/PrimeLogo';
import VipLogo from 'components/icons/vipDashboard/VipLogo';
import { toThousandsSeparator, toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/account/vipDashboard/headerBar.scss';

export const HeaderBar = ({ expirationDate, firstName, isAccountOverview, isPrime, spendPoints, spendPointsDollarValue }, { testId }) => (
  <div className={css.headerBar} data-test-id={testId('vipDashboardHeaderBar')}>
    <div>
      <VipLogo />
      { !!isPrime && <PrimeLogo /> }
    </div>
    {
      isAccountOverview
        ? <div className={css.goToRewardsLink}><MartyLink to="/rewards/dashboard" data-test-id={testId('viewDashboard')}>View your VIP Dashboard</MartyLink></div>
        : <div>Welcome <span>{firstName}!</span></div>
    }
    {
      !!spendPoints && !!spendPointsDollarValue && <div className={css.pointsSection}>
        <div>
          <MartyLink to="/rewards-terms-of-use" data-test-id={testId('goToTermsAndConditions')}>
            <Info />
          </MartyLink>
          {toThousandsSeparator(spendPoints)} VIP Points ({toUSD(spendPointsDollarValue)})
        </div>
        <div>expires {expirationDate}</div>
      </div>
    }
  </div>
);

HeaderBar.contextTypes = {
  testId: PropTypes.func
};

HeaderBar.defaultProps = {
  expirationDate: '11/11/' + new Date().getFullYear()
};

const mapStateToProps = ({ holmes }) => ({
  firstName: holmes ? holmes.firstName : ''
});

export default connect(mapStateToProps, {})(HeaderBar);
